<script>

import axios from 'axios';

import {
  UNIT_BLOOM, UNIT_MOVE, UNIT_SWORD, UNIT_MIND,
} from '@/scripts/constants';

export default {
  name: 'TabCareCoordinator',
  components: {},
  props: {
    currentTab: { type: Number, required: true },
    tabIndex: { type: Number, required: true },
  },
  data: () => ({
    loaded: false,
    loading: true,
    user_id: 0,
    isTransferringMembers: false,
    newCareCoordinator: null,
    careCoordinators: [],
    careCoordinator: [],
    fields: [
      {
        key: 'account_uuid',
        label: 'Account UUID',
      },
      {
        key: 'first_name',
        label: 'First Name',
      },
      {
        key: 'last_name',
        label: 'Last Name',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'updated_at',
        label: 'Updated Time',
      },
      {
        key: 'transfer',
        label: 'Transfer',
      },
    ],
    unitTagsOptions: [
      { text: 'DPT', value: UNIT_SWORD },
      { text: 'Bloom', value: UNIT_BLOOM },
      { text: 'Move', value: UNIT_MOVE },
      { text: 'Mind', value: UNIT_MIND },
    ],
    assignmentTypeOptions: [
      // eslint-disable-next-line max-len
      { value: 'normal', html: '<b>Normal</b>: Idlest one will be assigned new members when their backlog is at most double the size of the idlest "Half" CC\'s backlog' },
      // eslint-disable-next-line max-len
      { value: 'half', html: '<b>Half</b>: Idlest one will be assigned new members when their backlog is less than half the size of the idlest "Normal" CC\'s backlog' },
      { value: 'none', html: '<b>None</b>: Not considered for assignment' },
    ],
    pendingTransfers: {},
    page: 1,
    total: 0,
    itemsPerPage: 15,
    filters: {
      account_uuid: undefined,
      email: undefined,
    },
    items: [],
    selectedUnits: [],
  }),
  watch: {
    currentTab(value) {
      if (this.tabIndex === value && this.loaded === false) {
        this.fetchData();
      }
    },
  },
  async beforeMount() {
    this.user_id = this.$route.params.id;
  },
  methods: {
    fetchData() {
      this.loaded = true;
      this.loading = true;
      return axios.get(`/v1/professionals/${this.user_id}/care-coordinator`)
        .then(response => {
          this.careCoordinator = response.data;
          this.markUnits(response.data.units);
        })
        .catch(err => {
          this.$noty.error('Could not get care coordinator information');
          console.error('Could not fetch care  coordinator', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    markUnits(units) {
      const unitNames = units.map(unit => unit.unit);
      this.selectedUnits = this.unitTagsOptions
        .filter(option => unitNames.includes(option.value))
        .map(option => option.value);
    },
    saveDataConfirmation() {
      return this.$bvModal.msgBoxConfirm('Save Care Coordinator?')
        .then(result => {
          if (result) {
            this.careCoordinator.units = this.selectedUnits;
            this.saveData();
          }
        });
    },
    saveData() {
      axios.put(`v1/professionals/${this.user_id}/care-coordinator`, this.careCoordinator)
        .then(({ data }) => {
          if (data.error) {
            this.$noty.error(data.message);
            return;
          }
          this.$noty.success('Care Coordinator saved successfully');
        })
        .catch(err => {
          this.$noty.error('Could not save Care Coordinator');
          console.error('Could not save Care Coordinator', err);
        });
    },
  },
};
</script>

<template>
  <b-tab title="Care Coordinator">
    <b-card-text>
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form-group class="mb-0" label="Care Coordinator" label-class="font-weight-bold pt-0" label-size="lg">
              <b-form-group label="Unit Tags" label-class="font-weight-bold" label-for="unit-tags">
                <b-form-checkbox-group id="unit-tags" v-model="selectedUnits" :options="unitTagsOptions" switches />
              </b-form-group>
              <b-form-group label="Assignment Type" label-class="font-weight-bold"
                label-for="radio-group-assignment-type">
                <b-form-radio-group id="radio-group-assignment-type" v-model="careCoordinator.assignment_type"
                  :options="assignmentTypeOptions" name="radio-group-assignment-type" stacked />
              </b-form-group>
            </b-form-group>
            <b-col cols="12">
              <b-button variant="primary" class="float-right" @click="saveDataConfirmation">Save CC configs</b-button>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </b-card-text>
  </b-tab>
</template>
